import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './AppRoot.jsx'
import './css/global.css' // Import global styles
import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from './context/LanguageContext'
import { initMonitoring } from './utils/monitoring'

initMonitoring();
console.log('🚀 APP RELOADED v4.83 ' + new Date().toISOString());
console.log('CarWash Pro build', __BUILD_HASH__, __BUILD_DATE__);

// ── Auto-recuperación de "deployment skew" ───────────────────────────────
// Si la app quedó abierta de un deploy anterior y un chunk lazy ya no existe
// en el deploy nuevo (TypeError: Failed to fetch dynamically imported module),
// Vite emite 'vite:preloadError'. Recargamos UNA vez para tomar el bundle
// nuevo completo, en lugar de mostrar la pantalla de crash.
window.addEventListener('vite:preloadError', (event) => {
    const KEY = 'cw_chunk_reload_at';
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 60_000) return; // evitar loop de recargas
    sessionStorage.setItem(KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
});
// PWA: banner "Nueva versión disponible" + chequeo al volver del background.
// (Antes: recarga silenciosa que podía caer en medio de un cobro, y en iOS la
// app en memoria pasaba días sin chequear → bundle viejo hasta reabrir 2 veces.)
import { registerSW } from 'virtual:pwa-register'

function showUpdateBanner(onAccept) {
    if (document.getElementById('pwa-update-banner')) return;
    const banner = document.createElement('div');
    banner.id = 'pwa-update-banner';
    banner.style.cssText = [
        'position:fixed', 'left:12px', 'right:12px',
        'bottom:calc(env(safe-area-inset-bottom, 0px) + 72px)',
        'z-index:2147483647', 'display:flex', 'align-items:center', 'gap:12px',
        'padding:12px 16px', 'border-radius:14px',
        'background:#13293D', 'color:#fff',
        'box-shadow:0 12px 32px rgba(14,27,42,0.35)',
        'font-family:Inter,-apple-system,system-ui,sans-serif', 'font-size:14px',
    ].join(';');
    banner.innerHTML = `
        <span style="flex:1;font-weight:600;">Nueva versión disponible</span>
        <button id="pwa-update-go" style="background:#E3B341;color:#0E1B2A;border:none;border-radius:10px;padding:10px 16px;font-weight:800;font-size:13px;cursor:pointer;min-height:40px;">Actualizar</button>
    `;
    document.body.appendChild(banner);
    document.getElementById('pwa-update-go').addEventListener('click', () => {
        const btn = document.getElementById('pwa-update-go');
        btn.textContent = 'Actualizando…';
        btn.disabled = true;
        onAccept();
    });
}

if (window.Capacitor?.isNativePlatform?.()) {
    // Binario nativo (iOS/Android): los assets viajan dentro del binario y los
    // sirve el scheme handler local — un SW solo puede servir stale tras un
    // update de la app. No se registra, y se desaloja cualquier resto de
    // instalaciones anteriores (registration + Cache Storage precacheado).
    try {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations?.()
                .then(registrations => registrations.forEach(r => r.unregister()))
                .catch(() => {});
        }
        if ('caches' in window) {
            caches.keys()
                .then(keys => keys.forEach(key => caches.delete(key)))
                .catch(() => {});
        }
    } catch { /* webview sin estas APIs: nada que limpiar */ }
} else if (import.meta.env.DEV) {
    navigator.serviceWorker?.getRegistrations?.().then(registrations => {
        registrations.forEach(registration => registration.unregister());
    });
} else {
    const updateSW = registerSW({
        onNeedRefresh() {
            showUpdateBanner(() => updateSW(true));
        },
        onRegisteredSW(_swUrl, registration) {
            if (!registration) return;
            const check = () => registration.update().catch(() => {});
            // Chequeo periódico + al traer la app al frente (clave en PWA iOS,
            // donde la app vive días en memoria sin recargar la página).
            setInterval(check, 60 * 60 * 1000);
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') check();
            });
        },
        onOfflineReady() {
            console.log('App lista para usar offline');
        },
        immediate: true,
    })
}

ReactDOM.createRoot(document.getElementById('app')).render(
    <React.StrictMode>
        <LanguageProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </LanguageProvider>
    </React.StrictMode>
)
